import { useState, useEffect } from 'react'

import config from 'config'
import { IProductSearchResponse } from 'models/SearchResponse'
import { PENDING_REVIEW, EDITS_REQUESTED, ARCHIVED, READY_FOR_APPROVAL } from 'models/SearchResult'
import { useAuth0Authentication } from './useAuth0Authentication'

export type ManageProductCounts = {
    pendingReview: number,
    editsRequested: number,
    archived: number,
}

export const useManagedProductCounts = () => {

    const [manageProductCounts, setManageProductCounts] = useState<ManageProductCounts>(null)
    const [state, refetch] = useState({})
    const refresh = () => refetch({});

    const { getAuth0AccessToken } = useAuth0Authentication()

    useEffect(() => {

        const getManageProductCounts = async () => {

            const accessToken: string = await getAuth0AccessToken()
        
            const getCount = async (filter: string) => {
                const response = await fetch(
                `${config.apiUrl}/products/search?metadata.status=${filter}`
                    , {
                    method: 'GET',
                    redirect: 'follow',
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        "Content-Type": 'application/json'
                    }
                })
    
                const json: IProductSearchResponse = await response.json()
                return json.noOfResults
            } 
    
            const response = await Promise.all([
                getCount(PENDING_REVIEW),
                getCount(READY_FOR_APPROVAL),
                getCount(EDITS_REQUESTED),
                getCount(ARCHIVED),
            ])
    
            setManageProductCounts({
                pendingReview: response[0] + response[1],
                editsRequested: response[2],
                archived: response[3],
            })
        }

        getManageProductCounts()
           
    }, [state])

    return {
        manageProductCounts,
        refresh
    }
}